package horcrux.frontend.common.views.feedbackform

import horcrux.common.api.dtos.types.UserFeedback
import horcrux.common.api.APILimits
import horcrux.frontend.common.State
import horcrux.frontend.common.isInvalid
import horcrux.frontend.common.getStringValueOrEmpty
import horcrux.frontend.common.value
import mui.material.FormControlMargin
import mui.material.FormControlVariant
import mui.material.TextField
import react.FC
import react.Props
import react.ReactNode
import react.dom.onChange

external interface FeedbackFormProps : Props {
    var userFeedbackMaybeState: State<UserFeedback?>
    var feedbackType: FeedbackType
}

enum class FeedbackType(val formLabel: String) {
    FEEDBACK("Tell Us What You Think"),
    ERROR_REPORT("Tell Us What Went Wrong");
}

val FeedbackForm = FC<FeedbackFormProps> { props ->
    val isInvalidUserFeedback = props.userFeedbackMaybeState.isInvalid()
    TextField {
        this.autoFocus = true
        this.margin = FormControlMargin.dense
        this.id = "enter-user-feedback"
        this.label = ReactNode(props.feedbackType.formLabel)
        this.fullWidth = true
        this.variant = FormControlVariant.outlined
        this.error = isInvalidUserFeedback
        this.multiline = true
        this.minRows = 5
        this.value = props.userFeedbackMaybeState.getStringValueOrEmpty()
        this.helperText =
            if (isInvalidUserFeedback) ReactNode("Feedback must be less than ${APILimits.MAX_USER_FEEDBACK_SIZE} characters") else null
        this.onChange = {
            val userFeedbackValue = it.value()
            val userFeedbackMaybe = if (userFeedbackValue.isEmpty()) {
                null
            } else {
                UserFeedback(userFeedbackValue)
            }
            props.userFeedbackMaybeState.set(userFeedbackMaybe)
        }
    }
}
